import endpoints from "@config/endpoints";
import { getData, getDataWithCache, postDataJSON } from "@services/CommonApiService";
import { getDeliveryOutcomeByPregnancyId } from "@services/pregnancyApiServices";
import { toast } from "react-toastify";
import { PNC_API_DETAILS, PNC_ERROR_MESSAGES } from "../PNCConstants";

export const getPNCServiceListByServiceSubCategory = async (pregnancyId: any, pncNo:any, pncVisitDate:any) => {
    try {
        const res = await getData<any>(`${endpoints.getPNCServiceListByServiceSubCategory}/${pregnancyId}/${pncNo}/${pncVisitDate}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.BACKDATED_ENTRY), {
            position: "top-center"
        });
    };
};

export const getDeliveryOutcome = async (pregnancyId: any) => {
    try {
        const res = await getDeliveryOutcomeByPregnancyId(pregnancyId);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.DELIVERY_OUTCOME), {
            position: "top-center"
        });
    };
};

export const getTabletCount = async (pregnancyId: any) => {
    try {
        const res = await getData<any>(`${endpoints.getANCTabletCount}/${pregnancyId}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.TABLET_COUNT), {
            position: "top-center"
        });
    };
};

export const getPlaceOfDelivery = async () => {
    try {
        const res = await getDataWithCache<any>(endpoints.placeOfDelivery);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.PLACE_OF_DELIVERY), {
            position: "top-center"
        });
    };
};

export const getContraceptionMethod = async () => {
    try {
        const res = await getDataWithCache<any>(endpoints.contraceptionMethod);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.CONTRACEPTION_METHOD), {
            position: "top-center"
        });
    };
};

export const getServiceReport = async (reportName: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getServiceReport}/${reportName}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.SERVICE_REPORT), {
            position: "top-center"
        });
    };
};

export const getContraceptionType = async (methodId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.contraceptionType}/${methodId}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.CONTRACEPTION_TYPE), {
            position: "top-center"
        });
    };
};

export const getServiceSubcategory = async (currServiceCategoryId: any, isDeliveryOutside:boolean) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getServiceSubCategory}/${currServiceCategoryId}/${isDeliveryOutside}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.SERVICE_SUB_CATEGORY), {
            position: "top-center"
        });
    };
};

export const getServiceCategoryForNonPregnant = async () => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getServiceCategoryForNonPregnant}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.NON_PREGNANT_SUB_CATEGORY), {
            position: "top-center"
        });
    };
};

export const createPNCMother = async (payload: any) => {
    try {
        const res = await postDataJSON<any>(`${endpoints.createPNCMother}`, payload);
        return res;
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.POST_API_ERROR_MESSAGE(PNC_API_DETAILS.CREATE_PNC), {
            position: "top-center"
        });
    };
};

// Child PNC

export const getServiceReportForChild = async (serviceCode: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getServiceReportForChild}/${serviceCode}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.SERVICE_REPORT), {
            position: "top-center"
        });
    };
};

export const getMethodofTreatment = async () => {

    try {
        const res = await getDataWithCache<any>(endpoints.getMethodOfTreatment);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.METHOD_OF_TREATMENT), { 
            position: "top-center"
        });
    };
};

export const createPNCChild = async (payload: any) => {
    
    try {
        const res = await postDataJSON<any>(`${endpoints.createPNCChild}`, payload);
        return res;
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.POST_API_ERROR_MESSAGE(PNC_API_DETAILS.CREATE_CHILD_PNC), {
            position: "top-center"
        });
    };
};

export const getCompletedHbncServiceList = async (visitServiceId: any) => {

    try {
        const res = await getData<any>(`${endpoints.getCompletedHbncServiceList}/${visitServiceId}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.HBNC_SERVICE_LIST), {
            position: "top-center"
        });
    };
};

export const ServiceSubcategoryListByChildBeneficiaryHbncNo = async (benefId: any, hbncNo: any) => {
    const visitNo = Number(hbncNo);
    if (!Number.isInteger(visitNo) || visitNo <= 0) return;

    try {
        const res = await getData<any>(`${endpoints.getServiceSubcategoryListByChildBeneficiaryHbncNo}/${benefId}/${visitNo}`);
        if (res && res.data && Object.keys(res.data).length > 0) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.SERVICE_SUB_CATEGORY_LIST), {
            position: "top-center"
        });
    }
};

export const getChildTreatmentInfo = async () => {

    try {
        const res = await getDataWithCache<any>(endpoints.getChildTreatmentInfo);

        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.CHILD_TREATMENT), { 
            position: "top-center"
        });
    };
};

export const recentVisitDatesApi = async (payLoad: any) => {
    try {
        const res = await postDataJSON<any>(`${endpoints.recentVisitDates}`, payLoad);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        } else {
            return null;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.errorInRecentVisitDate, {
            position: "top-center"
        });
    };
};

export const getChildBeneficiaries = async (beneficiaryId: any) => {
    try {
        const res = await getData<any>(`${endpoints.getChildBeneficiaries}/${beneficiaryId}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(PNC_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(PNC_API_DETAILS.DELIVERY_OUTCOME), {
            position: "top-center"
        });
    };
};
